import { CodeIcon, DocumentIcon } from '../icons/Icons'
import styles from './ViewToggle.module.css'

interface ViewToggleProps {
  mode: 'pdf' | 'code'
  onToggle: () => void
  disabled?: boolean
}

export function ViewToggle({ mode, onToggle, disabled }: ViewToggleProps) {
  return (
    <button
      className={styles.toggle}
      onClick={onToggle}
      disabled={disabled}
      title={mode === 'pdf' ? 'Edit LaTeX code' : 'View PDF'}
    >
      {mode === 'pdf' ? (
        <CodeIcon className={styles.icon} />
      ) : (
        <DocumentIcon className={styles.icon} />
      )}
    </button>
  )
}
